import { LitElement, html, css } from 'lit-element';

// These are the shared styles needed by this element.
import { htPandoraEditableStyles } from './styles/ht-pandora-editable-styles';
import { ROUTES } from '../constants/routes';
import { UPDATE_WARNINGS } from '../constants/updateWarnings';
import { LINKS } from '../constants/links';
import { OPTIONS } from '../constants/options';
import { config } from '../functions/config';
import { postDataFactory } from '../functions/postDataFactory';
import { createNotificationObj } from '../functions/notificationFactory';
import { changePage } from '../functions/changePage';
import { getFieldSectionLinks } from '../functions/fieldSectionLink';

import './htPandoraFormWrapper';

class htPandoraEditableContractDates extends LitElement {
    static get properties() {
        return {
            contract: { type: Object },
            fields: { type: Array },
            _complete: { type: Boolean }
        };
    }

    constructor() {
        super();
        this.postData = postDataFactory({ fetch: window.fetch, apiEndPoint: `${config.contractAPI}` });
        this._complete = false;
    }

    _submitContractEdit() {
        const formData = JSON.parse(this.shadowRoot.querySelector('ht-pandora-form-wrapper').getAttribute('formdata'));
        formData.id = this.contract.id;

        const sendUpdate = new CustomEvent('send-update', {
            detail: {
                changes: formData,
                table: 'contract',
                post: this.postData,
                element: this
            }
        });
        this.dispatchEvent(sendUpdate);
    }

    _formCompleteToggle(e) {
        this._complete = e.detail.complete;
    }

    shouldUpdate() {
        if(this.contract !== null) return true;
        return false;
    }

    _cancelEdits() {
        this.shadowRoot.querySelector('ht-pandora-form-wrapper').setAttribute('formdata', '{}');
    }

    _closeCancellation() {
        const closeEdit = new CustomEvent('close-edit', {
            detail: {
                element: this
            }
        });
        this.dispatchEvent(closeEdit);
    }

    _formDataUpdated(e) {
        this._updateEndDateInContract(e.detail.formdata);
    }

    _updateEndDateInContract(data) {
        if(data.start_date) {
            let futureEndDate = new Date(data.start_date);
            futureEndDate.setFullYear(futureEndDate.getFullYear() + 1);
            futureEndDate.setDate(futureEndDate.getDate() - 1);
            // Converts date objecto into YYYY-MM-DD format
            const end_date = futureEndDate.toISOString().split('T')[0];
            const start_date = data.start_date;
            this.shadowRoot.querySelector('ht-pandora-form-wrapper').setAttribute('formdata', JSON.stringify({end_date, start_date}))
        }
    }

    static get styles() {
        return css`${htPandoraEditableStyles}`;
    }

    render() {
        return html`
            <div class="form-section-title">
                <h2>Changing Dates for: ${this.contract.customer_facing_id}</h2>
            </div>
            <form @submit="${e => e.preventDefault()}">
                <ht-pandora-form-wrapper
                    @form-complete="${this._formCompleteToggle}"
                    @form-data="${this._formDataUpdated}"
                    fields="${JSON.stringify(this.fields)}"
                    item="${JSON.stringify(this.contract)}"
                ></ht-pandora-form-wrapper>
                <div class="buttons">
                    <button class="ht-button ht-button-secondary" type="button" @click="${() => this._closeCancellation()}">Back</button>
                    <button ?disabled="${!this._complete}" class="ht-button" type="button" @click="${() => this._submitContractEdit()}">Submit</button>
                </div>
            </form>
        `;
    }
}

window.customElements.define('ht-pandora-editable-contract-dates', htPandoraEditableContractDates);
